import { Logger } from '@mntn-dev/logger'

export const SessionManagerLogger = Logger('SessionManager')
